import React, { useContext } from "react";
import intertech from "../icons/intertech.png";
import denizbank from "../icons/denizbank.png";
import denizbankag from "../icons/denizbankag.png";
import denizfactoring from "../icons/denizfactoring.png";
import yapikredi from "../icons/yapikredi.png";
import { useTranslation, Trans } from "react-i18next";
import "../styles/Resource.css";
import { DataContext } from "../contexts/DataContext";

const Resource = () => {
  const { t } = useTranslation();

  return (
    <section id="resource">
      <div className="resourceGeneral">
        <div id="emptyDivResource"></div>
        <h2 className="header-item-resource">{t("resourceKits")}</h2>
        <h5 className="header-item-small">
          {t("resourceSubtitle")}
        </h5>

        <div className="intertech-logo">
          <img className="logo-intertech" src={intertech} alt="Intertech" />
        </div>

        <div className="image-grid-resource">
          <div className="image-item-resource">
            <img className="img-logo" src={denizbank} alt="DenizBank" />
          </div>
          <div className="image-item-resource">
            <img className="img-logo" src={denizbankag} alt="DenizBank AG" />
          </div>
          <div className="image-item-resource">
            <img
              className="img-logo"
              src={denizfactoring}
              alt="Deniz Faktoring"
            />
          </div>
          <div className="image-item-resource">
            <img
              id="yapikredi"
              className="img-logo"
              src={yapikredi}
              alt="Yapı Kredi Faktoring"
            />
          </div>
        </div>
        <p className="header-item-small partners-text">{t("partnersText")}</p>
      </div>
    </section>
  );
};
export default Resource;